function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Testing'))  {
    return [
    {
      title: 'Testing',
      icon: 'mdi-test-tube',
      items: [
        {
          icon: 'mdi-beaker',
          title: 'Inventory',
          path: '/TesInventory'
        },
        // {
        //   icon: 'mdi-file-document-outline',
        //   title: 'Reports',
        //   path: '/TesReports'
        // }
      ]
    }
  ] } else return []
}

export default buildMenu